module.exports = __webpack_public_path__ + "static/img/200311.e4aea900.png";